import DPIntroCore, {
	LAYER_CLASSES, EVENTS, COMMANDS
} from './DPIntroCore';
import BulletsAnimation from '../../../../includes/assets/js/modules/BulletsAnimation';
import {
	$S,
	i18n,
	getWinBB
} from '../utils/dp-utils';
import BrowserSupport from '../../../../includes/assets/js/modules/BrowserSupport';
import Color from 'color';
import DPColors from '../../../../includes/assets/js/modules/DPColors';
import DPIncUtils from '../../../../includes/assets/js/modules/DPIncUtils';
import DPUserVisitCounter from './DPUserVisitCounter';
import classNames from 'classnames';
import DpitHooks from '../../../../includes/assets/js/modules/DpitHooks';



const SCROLL_SPEED_0_MS = 1000;
const SCROLL_MAX_TIME_COEF = 3;



export default class DPIntroTour {

	constructor(mainCfg, tourCfg) {
		if (mainCfg.dpDebugEn) {
			console.log('DPIntroTour');
			console.log('jQuery v: ' + jQuery.fn.jquery);
		}
		this.tourCfg = tourCfg;
		this.mainCfg = mainCfg;
		this.tourId = null;
		if (this.tourCfg) {
			this.tourCfg.text_styles = { ...this.mainCfg.text_styles, ...this.tourCfg.text_styles };
			this.tourId = this.tourCfg.tourId;
		}

		this.currentUrl = new URL(window.location);
		this.hookOptions = {
			tourId: this.tourId,
			currentUrl: this.currentUrl
		};
		this.startStep = this.getDpUrlParam('dp_qp_step');
		if (this.shouldInitialize()) {
			this.initWrapperLayer();
			this.initBulletsAnimation();
			if (this.tourCfg) {
				this.updateTheme();
				this.initTriggers();
				this.initCore();
				this.initTour();
			}
		}
	}

	shouldInitialize() {
		const shouldInit = DpitHooks.applyFilters('shouldInit', true, this.hookOptions);
		const diviBuilderMode = this.currentUrl.searchParams.get('et_fb') === '1';
		const oxygenBuilderMode = this.currentUrl.searchParams.get('ct_builder') === 'true';
		return !(diviBuilderMode || oxygenBuilderMode) && BrowserSupport.isSupported() && shouldInit;
	}

	getDpUrlParam(id, defVal = null) {
		return DPIncUtils.getDpUrlParam(id, this.mainCfg.queryParamsDefs, this.currentUrl, defVal);
	}

	initBulletsAnimation() {
		this.bulletsAnimation = new BulletsAnimation(
			'.' + LAYER_CLASSES.overlayContainer,
			`${LAYER_CLASSES.rbAnim}-${this.tourId}`,
			[LAYER_CLASSES.rbAnim], 7, 90);
	}

	initTriggers() {
		this.triggers = [];
		this.tourCfg.triggers.forEach((triggerCfg, idx) => {
			this.triggers.push({
				idx: idx,
				config: triggerCfg,
				jElement: (triggerCfg.selector === 'window') ? $(window) : $S(triggerCfg.selector),
				isInRun: false,
				wasRunInThisSession: false
			});
		});
		this.activeTriggerIdx = 0;
	}

	initRootWrapper() {
		if (!this.dpIntroWrapper) this.dpIntroWrapper = document.createElement('div');
		$(this.dpIntroWrapper).addClass(LAYER_CLASSES.wrapper);
		const tourIdWrapper = this.getTourIdPostfix(LAYER_CLASSES.wrapper);
		$(this.dpIntroWrapper).addClass(tourIdWrapper);
		$(this.dpIntroWrapper).attr('id', tourIdWrapper);
	}

	initWrapperLayer() {
		this.dpIntroWrapper = document.createElement('div');
		this.initRootWrapper();

		document.body.appendChild(this.dpIntroWrapper);

		this.dpIntroMain = document.createElement('div');
		$(this.dpIntroMain).addClass(LAYER_CLASSES.main);
		this.dpIntroWrapper.appendChild(this.dpIntroMain);


		this.onResize();
	}

	onResizeWrap = () => {
		this.onResize();
	}

	onResize() {
		BrowserSupport.vHFix(this.dpIntroWrapper);
		DPIncUtils.setMobileSizeCoef(this.dpIntroWrapper, this.tourCfg?.text_styles, this.mainCfg?.mobile_break_points?.mobile);
		this.adjustBulletsAnimationSizeVar();
	}

	isMobileSize(breakPointOverride = null) {
		let breakPoint = this.mainCfg.mobile_break_points ? this.mainCfg.mobile_break_points.mobile : 500;
		if (breakPointOverride !== null) breakPoint = breakPointOverride;

		const winSize = getWinBB(breakPoint);
		return winSize.width <= breakPoint;
	}

	isOnLoadTrigger(trigger) {
		return trigger.config.on == 'load' || this.shouldAlwaysRunOnLoad();
	}

	isOnLoadDisabled(trigger) {
		return false;
	}

	shouldAlwaysRunOnLoad() {
		return this.getDpUrlParam('dp_qp_run_always_on_load') === '1';
	}

	shouldRunAtCurrentDevice() {
		return true;
	}

	initTourWithSelectedTrigger(trigger) {
		let run = true;
		var visitedCnt = DPUserVisitCounter.getVisitCount(this.mainCfg);

		if (trigger.config.first_user_visit_only) {
			let limit = trigger.config.first_n_user_visit || 1;
			run = (visitedCnt <= limit);
		}
		if (trigger.config.allow_just_for_logged_in_users && this.mainCfg.currentUserId == 0) {
			run = false;
		}
		if (trigger.config?.disable_for_roles?.length && this.mainCfg.currentUserRoles && this.mainCfg?.currentUserRoles?.length) {
			for (const val of trigger.config.disable_for_roles) {
				if (this.mainCfg.currentUserRoles.includes(val)) {
					run = false;
					break;
				}
			}
		}

		if (!this.shouldRunAtCurrentDevice(trigger)) run = false;

		if (run || this.shouldAlwaysRunOnLoad()) {
			if (this.isOnLoadTrigger(trigger) && !this.isOnLoadDisabled(trigger)) {
				this.startTourWithAnimation(trigger, this.startStep);
			} else {
				if (!trigger.config.once_per_session_only || !trigger.wasRunInThisSession) {
					setTimeout(() => {
						this.activateTrigger(trigger);
					}, 300);
				}
			}
		}
	}

	initTour() {
		this.triggers.forEach((trigger) => {
			this.initTourWithSelectedTrigger(trigger);
		});
	}

	activateTrigger(trigger) {
		if (!this.isOnLoadTrigger(trigger)) {
			trigger.jElement.on(trigger.config.on, (event) => {
				let start = true;
				if (trigger.config.specific_key_pressed && event) {
					if (trigger.config.on === 'keydown' ||
						trigger.config.on === 'keypress' ||
						trigger.config.on === 'keyup') {
						start = trigger.config.specific_key_pressed == event.keyCode;
					}
				}
				if (start) {
					if (this.startTour(trigger) && event) {
						event.preventDefault();
						event.stopPropagation();
					}
				}
			});
		}
	}

	createCoreInstance() {
		return new DPIntroCore(this.dpIntroMain, this.mainCfg, this.tourId);
	}

	afterIntroCoreInit() {

	}

	initCore() {
		this.core = this.createCoreInstance();
		this.steps = this.initPreprocessSteps();
		this.afterIntroCoreInit();
		if (this.mainCfg.dpDebugEn) console.log('ROW STEPS', this.steps);
		if (this.steps && this.isStepsEnough2Start()) {

			this.core.setOptions(this.getIntroCoreOptions());
		}
		this.checkStickyTheme();

	}

	checkStickyTheme() {

		if (this.core) {
			if (this.core.isStickyTheme()) {
				$(this.dpIntroWrapper).addClass(LAYER_CLASSES.isStickyTheme);
				this.core.setOption('showProgress', true);
			}
			else {
				$(this.dpIntroWrapper).removeClass(LAYER_CLASSES.isStickyTheme);
				this.core.setOption('showProgress', this.tourCfg.behaviour.show_progress_bar);
			}
			this.core.actualizeTooltipMaxWidth();
		}

	}

	initPreprocessSteps() {
		let steps = $.parseJSON(this.tourCfg.steps);
		if (steps) {
			steps = steps.map((step) => {
				const preprocessedStep = {};
				Object.keys(step).forEach(paramName => {
					preprocessedStep[paramName] = DPIncUtils.decodeStepParamAdvancedVal(step[paramName], paramName, this.mainCfg.stepDefinitions, true, true);
				});
				return preprocessedStep;
			});
		}
		return steps;
	}

	getIntroCoreOptions() {
		return {
			steps: this.steps,
			scrollToElement: true,
			scrollTo: 'all',
			enable_interaction: '0',
			showStepNumbers: this.tourCfg.behaviour.show_step_numbers, // this.tourCfg.showStepNumbers,
			showProgress: this.tourCfg.behaviour.show_progress_bar,//  this.tourCfg.showProgress,
			showBullets: this.tourCfg.behaviour.show_bullet_navigation,// this.tourCfg.showBullets,
			labeling: this.tourCfg.labeling,
			nextLabel: this.tourCfg.labeling.nextLabel || i18n('next', this.mainCfg.i18n),
			prevLabel: this.tourCfg.labeling.prevLabel || i18n('back', this.mainCfg.i18n),
			skipLabel: this.tourCfg.labeling.skipLabel || i18n('skip', this.mainCfg.i18n),
			doneLabel: this.tourCfg.labeling.doneLabel || i18n('done', this.mainCfg.i18n),
			exitOnOverlayClick: this.tourCfg.behaviour.exitOnOverlayClick,
			hide_previous_step_button: this.tourCfg.behaviour.hide_previous_step_button,
			hideNextAlways: this.tourCfg.behaviour.hideNextAlways,
			hide_skip_button: this.tourCfg.behaviour.hide_skip_button,
			overlayBlurred: this.tourCfg.behaviour.overlayBlurred,
			disable_navigation_by_bullets: this.tourCfg.behaviour.disable_navigation_by_bullets,
			max_tooltip_width: this.tourCfg.behaviour.max_tooltip_width,
			skip_absent_ref_el: this.tourCfg.behaviour.skip_absent_ref_el,
			customTextStylesEn: !$.isEmptyObject(this.mainCfg.text_styles),
			...this._getScrollSpeed(this.tourCfg.behaviour.scrollSpeed),
		};
	}

	_getScrollSpeed(cfgScrollSpeed) {
		const cfgScrollSpeedSanitized = Math.max(Math.min(cfgScrollSpeed, 100), 0);
		const scrollSpeedPerPageMs = cfgScrollSpeedSanitized === 100 ?
			0 :
			0.0802 * Math.pow(cfgScrollSpeedSanitized, 2) - 18.01 * cfgScrollSpeedSanitized + SCROLL_SPEED_0_MS;
		return {
			scrollSpeedPerPageMs: scrollSpeedPerPageMs,
			maxScrollSpeedPerPageMs: scrollSpeedPerPageMs * SCROLL_MAX_TIME_COEF
		};
	}

	setInRunClasses() {
		$(this.dpIntroWrapper).parent().addClass(LAYER_CLASSES.relativePosition);
		$(this.dpIntroWrapper).addClass(LAYER_CLASSES.tourInRun);
		$(document.documentElement).addClass(classNames({
			[LAYER_CLASSES.tourInRun]: true,
			[this.getTourIdPostfix()]: true,
			[LAYER_CLASSES.builderInRun]: this.core?.isBuilder
		}));
	}

	clearInRunClasses() {
		$(this.dpIntroWrapper).parent().removeClass(LAYER_CLASSES.relativePosition);
		$(this.dpIntroWrapper).removeClass(LAYER_CLASSES.tourInRun);
		$(document.documentElement).removeClass(classNames([
			LAYER_CLASSES.tourInRun,
			this.getTourIdPostfix(),
			LAYER_CLASSES.builderInRun
		]));
	}

	getTourIdPostfix(prefix = LAYER_CLASSES.tourInRun) {
		return `${prefix}-${this.tourId}`;
	}

	isStepsEnough2Start() {
		return this.steps.length > 0;
	}

	updateTheme() {
		this.initRootWrapper();
		if (this.tourCfg && this.tourCfg.theme) {
			$(this.dpIntroWrapper).addClass(this.tourCfg.theme);
		}

		this.setAccentColor(this.tourCfg.accentColor);
		this.setRadiuses(this.tourCfg);
		DPIncUtils.setTextStyles(this.dpIntroWrapper, this.tourCfg?.text_styles, this.mainCfg?.mobile_break_points?.mobile);
		this.checkStickyTheme();
	}

	setRadiuses() {
		if (this.tourCfg.tooltip_radius >= 0) {
			this.dpIntroWrapper.style.setProperty('--tooltip-border-radius', this.tourCfg.tooltip_radius + 'px');
		}
		if (this.tourCfg.highlight_radius >= 0) {
			this.dpIntroWrapper.style.setProperty('--highlight-border-radius', this.tourCfg.highlight_radius + 'px');
		}
		if (this.tourCfg.button_radius >= 0) {
			this.dpIntroWrapper.style.setProperty('--button-border-radius', this.tourCfg.button_radius + 'px');
			this.dpIntroWrapper.style.setProperty('--button-border-radius-sm', 0.3 * this.tourCfg.button_radius + 'px');
		}
	}


	adjustBulletsAnimationSizeVar() {
		if (this.tourCfg?.behaviour?.bulletAnimSize) {
			const isMobileSize = this.isMobileSize(600);
			const size1Bullet = isMobileSize ? this.tourCfg.behaviour.bulletAnimSize / 6 : this.tourCfg.behaviour.bulletAnimSize / 15; // include gap
			this.dpIntroWrapper.style.setProperty('--bullet-anim-size', `${size1Bullet}vw`);
			this.dpIntroWrapper.style.setProperty('--bullet-anim-gap', `${size1Bullet / 4}vw`);
			this.dpIntroWrapper.style.setProperty('--bullet-anim-border-radius', `${this.tourCfg.behaviour.bulletAnimBorderRadius}%`);
		}
	}

	adjustContrastToOverlayVar() {
		if (this.tourCfg.behaviour.overlayBlurred) {
			this.dpIntroWrapper.style.setProperty('--dpit-shadow-color', '30, 30, 30');
			this.dpIntroWrapper.style.setProperty('--dpit-shadow-alpha', 0.05);
		}
	}

	setAccentColor(accentColor, actualizeAutoFocus = false) {
		if (!accentColor) accentColor = this.tourCfg.accentColor;
		if (accentColor) {
			const accent = Color.rgb(accentColor);
			if (accent) {
				$(this.dpIntroWrapper).removeClass('dpit-light-accent');
				this.currentAccentColor = `${accent.red()}, ${accent.green()}, ${accent.blue()}`;
				this.dpIntroWrapper.style.setProperty('--accent-color', this.currentAccentColor);
				const accentContrastColor = DPColors.getContrastColor(accentColor, false);
				if (accentContrastColor) {
					if (accentContrastColor.isDark()) $(this.dpIntroWrapper).addClass('dpit-light-accent');
					const gentleAccentColor = accent.mix(accentContrastColor, 0.2);
					this.dpIntroWrapper.style.setProperty('--accent-color-gentle', `${gentleAccentColor.red()}, ${gentleAccentColor.green()}, ${gentleAccentColor.blue()}`);
					this.dpIntroWrapper.style.setProperty('--accent-contrast-color', `${accentContrastColor.red()}, ${accentContrastColor.green()}, ${accentContrastColor.blue()}`);
					const accentContrastInvColor = DPColors.getContrastColor(accentContrastColor, false);
					if (accentContrastInvColor) {
						this.dpIntroWrapper.style.setProperty('--accent-contrast-inv-color', `${accentContrastInvColor.red()}, ${accentContrastInvColor.green()}, ${accentContrastInvColor.blue()}`);
					}
				}
			}
		} else {
			this.currentAccentColor = '';
			this.dpIntroWrapper.style.removeProperty('--accent-color');
			this.dpIntroWrapper.style.removeProperty('--accent-contrast-color');
		}
		this.adjustContrastToOverlayVar();
		this.adjustBulletsAnimationSizeVar();
		if (actualizeAutoFocus) this.core?.actualizeAutoFocus();
	}

	setAsRunningTour() {
		if (!this.core.isThisInRun()) {
			if (!window.DpitApi) window.DpitApi = {
				[COMMANDS.goToNext]: () => this.core.goToNextStep(),
				[COMMANDS.goToPrev]: () => this.core.goToPreviousStep(),
				[COMMANDS.goToStep]: (stepIdx) => this.core.goToStep(stepIdx),
				[COMMANDS.exit]: () => this.core._exitIntro('skip'),
				[COMMANDS.setAccent]: (color) => this.setAccentColor(color, true),
				[COMMANDS.getScrollSpeed]: () => this.tourCfg?.behaviour?.scrollSpeed,
				[COMMANDS.setScrollSpeed]: (speedToSet) => this.core.setOptions(this._getScrollSpeed(speedToSet)),
				[COMMANDS.setCoreOptions]: (options) => this.core.setOptions(options)
			};
			this.setInRunClasses();

			if (this.core) {
				this.core.subscribeEvent(EVENTS.ended, this.onExitWrap);
				this.core.subscribeEvent(EVENTS.onResize, this.onResizeWrap);
			}

		}
	}



	resetAsRunningTour() {
		this.clearInRunClasses();
		window.DpitApi = null;
		this.core.unsubscribeEvent(EVENTS.ended, this.onExitWrap);
		this.core.unsubscribeEvent(EVENTS.onResize, this.onResizeWrap);
	}

	startTourWithAnimation(trigger, step = 0, forceStart = false, backward = false, animationTimeMs = 1100) {
		if (!this.tourCfg.behaviour.disableStartAnimation) {
			if (this.isStepsEnough2Start() && !this.core.isInRun()) {
				this.hideElementsAtStart();
				this.setAsRunningTour();

				this.core.addOverlayLayer(false, this.tourCfg.behaviour.overlayBlurred);
				this.bulletsAnimation.createAndRun(backward, this.core.overlayContainer);

				setTimeout(() => {
					//this.bulletsAnimation.stopReloadSpinner();
					this.bulletsAnimation.destroy();
					this.startTour(trigger, step, forceStart, true);
					this.adjustContrastToOverlayVar();
				}, animationTimeMs);
			}
		} else this.startTour(trigger, step, forceStart);
	}

	startTour(trigger, step = 0, forceStart = false, disableIsInRunCheck = false) {

		if (this.isStepsEnough2Start() && (disableIsInRunCheck || !this.core.isInRun()) && (forceStart || !trigger.config.once_per_session_only || !trigger.wasRunInThisSession)) {
			this.setAsRunningTour();
			this.hideElementsAtStart();
			trigger.isInRun = true;

			this.core.start(step, this.isInitializedBackward());
			if (this.mainCfg.dpDebugEn) console.log('Starting tour: ', this.tourCfg.tourName + ' (' + this.tourId + ')');
			trigger.wasRunInThisSession = true;
			this.activeTriggerIdx = trigger.idx;
			return true;
		}
		return false;
	}

	isInitializedBackward() {
		return false;
	}

	hideElementsAtStart() {
		if (this.tourCfg.hideElementsAtStart) {
			this._hideElementAtStart();
			setTimeout(this._hideElementAtStart.bind(this), 1000);
		}
	}

	_hideElementAtStart() {
		const jHideEl = $S(this.tourCfg.hideElementsAtStart);
		if (jHideEl && jHideEl.length) {
			jHideEl.each((idx, element) => {
				$(element).addClass('dpit-hidden-at-start').fadeOut(150);
			});
		}
	}

	showHiddenElementsAtStart() {
		$('.dpit-hidden-at-start').fadeIn(150).removeClass('dpit-hidden-at-start');
	}

	onExitWrap = (args) => {
		this.onExit(args.reason);
	}

	onExit(reason) {
		if (this.mainCfg.dpDebugEn) console.log('Exiting tour: ' + this.tourId + ' - reason: ' + reason);
		this.showHiddenElementsAtStart();
		this.triggers[this.activeTriggerIdx].isInRun = false;
		this.resetAsRunningTour();
	}

}